module.exports = __webpack_public_path__ + "img/contentleft.c5575761.png";